import { NewsletterSubscribe } from './newsletter_subscribe';

export default NewsletterSubscribe;
